import axios from "axios";
import * as API_LINKS from '../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_SETTING_LIST = 'FETCH_SETTING_LIST'
export const RECEIVE_SETTING_LIST = 'RECEIVE_SETTING_LIST'
export const FAILED_SETTING_LIST = 'FAILED_SETTING_LIST'

export function fetchSettingList(){

    return (dispatch, getState) => {
        let {authStore} = getState();
        let auth = null;
        if(authStore.authData){
            auth = authStore.authData.result.token;
        }
        dispatch({type: FETCH_SETTING_LIST});
        axios({
            method: 'post',
            url: API_LINKS.SETTING_LIST_URL,
            headers: {
                Authorization: auth
            },
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_SETTING_LIST,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_SETTING_LIST
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_SETTING_LIST
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_SETTING_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_SETTING_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_SETTING_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_SETTING_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}